import HandleError from "@utils/fetch-error-handle";

export const fetchMMVData = (payload: any) =>
  window
    // .ackoFetch(`${process.env.MO_BASE_SERVICE}/mmv?vehicle_type=car`)
    .ackoFetch(
      `${process.env.MO_V1}/mmv?vehicle_type=${
        window?.isBike ? "bike" : "car"
      }&journey_type=${window?.product}${
        payload?.mmv_version ? `&mmv_version=${payload?.mmv_version || ""}` : ""
      }`
    )
    .then(HandleError)
    .then(res => res.json());

export default {};
